<template>
  <div id="adminLinguas">
    <vue-headful title="Admin" lang="en" />
    <treeselect v-model="linguas" :clearable="true" :searchable="true" :multiple="true" :options="paises" placeholder="Select Languages" :open-on-click="true" :open-on-focus="true" :clear-on-select="true" :close-on-select="true" no-results-text="" no-options-text="" :normalizer="normalizer" />

    <div class="clearfix"></div>
    <button type="button" @click="submitLang" class="btn btn-primary float-right m-t-10">UPDATE</button>

    <div class="clearfix"></div><br /><hr /><br />
    <h3 class="text-uppercase">Translations</h3>
    <div class="tabs-langs">
      <b-tabs content-class="mt-3">
        <b-tab @click="sel = dt" :title="dt" v-for="(dt, index) in linguas" :key="index" :active="sel === dt">

          <ul class="nav nav-tabs" role="tablist" style="margin-bottom:20px;">
            <li :class="{'nav-link': 1, 'active': pagina == 'general'}" @click="pagina = 'general'">
              <a class="nav-link">General</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'home'}" @click="pagina = 'home'">
              <a class="nav-link">Home</a>
            </li>

            <li :class="{'nav-link': 1, 'active': pagina == 'reserved'}" @click="pagina = 'reserved'">
              <a class="nav-link">Reserved</a>
            </li>

            <li :class="{'nav-link': 1, 'active': pagina == 'cars'}" @click="pagina = 'cars'">
              <a class="nav-link">Cars</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'news'}" @click="pagina = 'news'">
              <a class="nav-link">News</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'pages'}" @click="pagina = 'pages'">
              <a class="nav-link">Pages</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'contacts'}" @click="pagina = 'contacts'">
              <a class="nav-link">Contacts</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'contapessoal'}" @click="pagina = 'contapessoal'">
              <a class="nav-link">Reserved Area Client</a>
            </li>
            <li :class="{'nav-link': 1, 'active': pagina == 'errors'}" @click="pagina = 'errors'">
              <a class="nav-link">Errors</a>
            </li>

            <li :class="{'nav-link': 1, 'active': pagina == 'emails'}" @click="pagina = 'emails'">
              <a class="nav-link">Emails</a>
            </li>

            <li :class="{'nav-link': 1, 'active': pagina == 'pdf'}" @click="pagina = 'pdf'">
              <a class="nav-link">PDF</a>
            </li>
          </ul>
          <div v-if="pagina == 'general'">
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Title</div>
                </div>
                <input v-model="traducoes['cookies-title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Description</div>
                </div>
                <input v-model="traducoes['cookies-desc-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Essentials Title</div>
                </div>
                <input v-model="traducoes['cookies-title-essentials-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Essentials Description</div>
                </div>
                <input v-model="traducoes['cookies-description-essentials-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Statistics Title</div>
                </div>
                <input v-model="traducoes['cookies-title-statistics-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Statistics Description</div>
                </div>
                <input v-model="traducoes['cookies-description-statistics-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Marketing Title</div>
                </div>
                <input v-model="traducoes['cookies-title-marketing-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cookies Marketing Deascription</div>
                </div>
                <input v-model="traducoes['cookies-description-marketing-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Accept Selected Cookies</div>
                </div>
                <input v-model="traducoes['cookies-accept-selected-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Accept All Cookies</div>
                </div>
                <input v-model="traducoes['cookies-accept-all-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reject Cookies</div>
                </div>
                <input v-model="traducoes['cookies-reject-all-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reserved Area</div>
                </div>
                <input v-model="traducoes['reserved_area-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Login</div>
                </div>
                <input v-model="traducoes['login-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Logout</div>
                </div>
                <input v-model="traducoes['logout-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Transmision Manual</div>
                </div>
                <input v-model="traducoes['manual-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Transmision Automatic</div>
                </div>
                <input v-model="traducoes['automatic-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reserve</div>
                </div>
                <input v-model="traducoes['reservar-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Copyright</div>
                </div>
                <input v-model="traducoes['copyright-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Price with VAT</div>
                </div>
                <input v-model="traducoes['reserved-totalciva-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Price without vat</div>
                </div>
                <input v-model="traducoes['reserved-totalsiva-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Calendar</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Jan</div>
                </div>
                <input v-model="traducoes['jan-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Fev</div>
                </div>
                <input v-model="traducoes['fev-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Mar</div>
                </div>
                <input v-model="traducoes['mar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Apr</div>
                </div>
                <input v-model="traducoes['apr-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">May</div>
                </div>
                <input v-model="traducoes['may-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Jun</div>
                </div>
                <input v-model="traducoes['jun-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Jul</div>
                </div>
                <input v-model="traducoes['jul-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Aug</div>
                </div>
                <input v-model="traducoes['aug-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Sep</div>
                </div>
                <input v-model="traducoes['sep-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Oct</div>
                </div>
                <input v-model="traducoes['oct-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Nov</div>
                </div>
                <input v-model="traducoes['nov-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Dec</div>
                </div>
                <input v-model="traducoes['dec-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Mon</div>
                </div>
                <input v-model="traducoes['mon-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Tue</div>
                </div>
                <input v-model="traducoes['tue-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Wed</div>
                </div>
                <input v-model="traducoes['wed-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Thu</div>
                </div>
                <input v-model="traducoes['thu-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Fri</div>
                </div>
                <input v-model="traducoes['fri-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Sat</div>
                </div>
                <input v-model="traducoes['sat-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Sun</div>
                </div>
                <input v-model="traducoes['sun-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Search Station</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Search</div>
                </div>
                <input v-model="traducoes['pesquisar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-out</div>
                </div>
                <input v-model="traducoes['levantamento-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-in</div>
                </div>
                <input v-model="traducoes['devolucao-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-out Date</div>
                </div>
                <input v-model="traducoes['levantamento_data-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-out Time</div>
                </div>
                <input v-model="traducoes['levantamento_hora-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-in Date</div>
                </div>
                <input v-model="traducoes['devolucao_data-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-in Time</div>
                </div>
                <input v-model="traducoes['devolucao_hora-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Date of Birth</div>
                </div>
                <input v-model="traducoes['aniversario-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Search</div>
                </div>
                <input v-model="traducoes['search_botao-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'home'">
            <h5>Home</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Home</div>
                </div>
                <input v-model="traducoes['home-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Home</div>
                </div>
                <input v-model="traducoes['home_title-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Our Fleet</div>
                </div>
                <input v-model="traducoes['nossa_frota-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title News</div>
                </div>
                <input v-model="traducoes['home_news-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle News</div>
                </div>
                <input v-model="traducoes['home_news1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <!-- <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Monday-Friday</div>
                </div>
                <input v-model="traducoes['seg-sexta-' + sel]" type="text" class="form-control">
              </div>
            </div> -->
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Monday</div>
                </div>
                <input v-model="traducoes['monday-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Tuesday</div>
                </div>
                <input v-model="traducoes['tuesday-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Wednesday</div>
                </div>
                <input v-model="traducoes['wednesday-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Thursday</div>
                </div>
                <input v-model="traducoes['thursday-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Friday</div>
                </div>
                <input v-model="traducoes['friday-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Saturday</div>
                </div>
                <input v-model="traducoes['sabado-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Sunday</div>
                </div>
                <input v-model="traducoes['domingo-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Holiday</div>
                </div>
                <input v-model="traducoes['feriados-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'cars'">
            <h5>Cars</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Car</div>
                </div>
                <input v-model="traducoes['car-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title car</div>
                </div>
                <input v-model="traducoes['car_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle car</div>
                </div>
                <input v-model="traducoes['car_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reserved</div>
                </div>
                <input v-model="traducoes['car_reservar-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Stations</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Stations</div>
                </div>
                <input v-model="traducoes['stations-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Stations</div>
                </div>
                <input v-model="traducoes['stations_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle Stations</div>
                </div>
                <input v-model="traducoes['stations_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Station Selected</div>
                </div>
                <input v-model="traducoes['estacao-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cars Stations</div>
                </div>
                <input v-model="traducoes['viaturas-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reserved Stations</div>
                </div>
                <input v-model="traducoes['reservar1-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'news'">
            <h5>News</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">News</div>
                </div>
                <input v-model="traducoes['news-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title News</div>
                </div>
                <input v-model="traducoes['news_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle News</div>
                </div>
                <input v-model="traducoes['news_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'contacts'">
            <h5>Contacts</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Contacts</div>
                </div>
                <input v-model="traducoes['contacts-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Contacts</div>
                </div>
                <input v-model="traducoes['contacts_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle Contacts</div>
                </div>
                <input v-model="traducoes['contacts_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Address</div>
                </div>
                <input v-model="traducoes['address-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <!-- TO USE! -->
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Department 1 Name</div>
                </div>
                <input v-model="traducoes['department1_desc_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Department 2 Name</div>
                </div>
                <input v-model="traducoes['department2_desc_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <!--  TO USE -->
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Form</div>
                </div>
                <input v-model="traducoes['form-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle Form</div>
                </div>
                <input v-model="traducoes['form_desc-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Name</div>
                </div>
                <input v-model="traducoes['nome-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Email</div>
                </div>
                <input v-model="traducoes['email1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Phone</div>
                </div>
                <input v-model="traducoes['phone1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Subject</div>
                </div>
                <input v-model="traducoes['assunto-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Message</div>
                </div>
                <input v-model="traducoes['mensgem-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Policy Acceptance</div>
                </div>
                <input v-model="traducoes['contact_acceptance-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Form Button</div>
                </div>
                <input v-model="traducoes['send-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Message Success</div>
                </div>
                <input v-model="traducoes['form_suc-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'errors'">
            <h5>404</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title</div>
                </div>
                <input v-model="traducoes['404_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">SubTitle</div>
                </div>
                <input v-model="traducoes['404_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <!--<vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="traducoes['404_text1-' + sel]"></vue-editor>-->
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Text</div>
                </div>
                <input v-model="traducoes['404_text1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Homepage</div>
                </div>
                <input v-model="traducoes['404_home-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Errors</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Lifting Station</div>
                </div>
                <input v-model="traducoes['erro-levantamento-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Lifting Date</div>
                </div>
                <input v-model="traducoes['erro-levantamentoData-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Return Date</div>
                </div>
                <input v-model="traducoes['erro-devolucaoData-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Birthday</div>
                </div>
                <input v-model="traducoes['erro-aniversario-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Select Driver</div>
                </div>
                <input v-model="traducoes['erro-driver-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmation 1</div>
                </div>
                <input v-model="traducoes['erro-confirmacao1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmation 2</div>
                </div>
                <input v-model="traducoes['erro-confirmacao2-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmation 3</div>
                </div>
                <input v-model="traducoes['erro-confirmacao3-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Register</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Driver Name </div>
                </div>
                <input v-model="traducoes['erro-driver_Name-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email </div>
                </div>
                <input v-model="traducoes['erro-email1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Password </div>
                </div>
                <input v-model="traducoes['erro-pass1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Repeat Password </div>
                </div>
                <input v-model="traducoes['erro-rpass1-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Address </div>
                </div>
                <input v-model="traducoes['erro-address_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Postal Code </div>
                </div>
                <input v-model="traducoes['erro-postal_Code_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">City</div>
                </div>
                <input v-model="traducoes['erro-city_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Country </div>
                </div>
                <input v-model="traducoes['erro-country_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Number </div>
                </div>
                <input v-model="traducoes['erro-license_Number_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Country </div>
                </div>
                <input v-model="traducoes['erro-license_Country_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type </div>
                </div>
                <input v-model="traducoes['erro-document_Type-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Number </div>
                </div>
                <input v-model="traducoes['erro-document_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Place </div>
                </div>
                <input v-model="traducoes['erro-document_Place-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">ID Number </div>
                </div>
                <input v-model="traducoes['erro-idNumber_register-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Passport Number </div>
                </div>
                <input v-model="traducoes['erro-passportNumber_register-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Phone Number </div>
                </div>
                <input v-model="traducoes['erro-phone_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Mobile Number </div>
                </div>
                <input v-model="traducoes['erro-mobile_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Insert Birth Date</div>
                </div>
                <input v-model="traducoes['erro-birth_date-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Birth Date</div>
                </div>
                <input v-model="traducoes['erro-insert-valid-birth_date-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Birth Date Must be Before Today</div>
                </div>
                <input v-model="traducoes['erro-birth_date-before-today-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Birth Date Updated - Toast</div>
                </div>
                <input v-model="traducoes['erro-birth_date-updated-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Birth Date Pattern</div>
                </div>
                <input v-model="traducoes['erro-aniversario_pattern-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Tax Number </div>
                </div>
                <input v-model="traducoes['erro-taxNumber_register-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Credit Card</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Card Number</div>
                </div>
                <input v-model="traducoes['erro-CreditCardNumber-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Card Name</div>
                </div>
                <input v-model="traducoes['erro-CreditCardName-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Card Date</div>
                </div>
                <input v-model="traducoes['erro-CreditCardDueDate-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>General</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Rental Dates</div>
                </div>
                <input v-model="traducoes['INVALID RENTAL DATES-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Pickup Date!</div>
                </div>
                <input v-model="traducoes['INVALID PICKUP DATE!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Droppoff Date!</div>
                </div>
                <input v-model="traducoes['INVALID DROPOFF DATE!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">The Pickup Station is Required</div>
                </div>
                <input v-model="traducoes['THE PICKUP STATION IS REQUIRED!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">No Multiple Prices Available 1</div>
                </div>
                <input v-model="traducoes['NO MULTIPLE PRICES ARE AVAILABLE FOR YOUR SELECTION.-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">No Multiple Prices Available 2</div>
                </div>
                <input v-model="traducoes['NO MULTIPLE PRICES IS AVAILABLE FOR THE SELECTION!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Customer not Authorized</div>
                </div>
                <input v-model="traducoes['CUSTOMER NOT AUTHORIZED-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Username or Password</div>
                </div>
                <input v-model="traducoes['INVALID USERNAME OR PASSWORD!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">The Pickup Station(s) will be Closed on the Requested Date</div>
                </div>
                <input v-model="traducoes['THE PICKUP STATION(S) WILL BE CLOSED ON THE REQUESTED DATE!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">The Droppoff Station(s) will be Closed on the Requested Date</div>
                </div>
                <input v-model="traducoes['THE DROPOFF STATION(S) WILL BE CLOSED ON THE REQUESTED DATE!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Oneway not Defined Between Pickup and Droppoff Stations</div>
                </div>
                <input v-model="traducoes['ONEWAY NOT DEFINED BETWEEN PICKUP AND DROPOFF STATIONS-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Preauthorization Credit Card Number</div>
                </div>
                <input v-model="traducoes['ERROR: INVALID PREAUTHORIZATION CREDIT CARD NUMBER!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">The Promotion Code Informed is not Valid</div>
                </div>
                <input v-model="traducoes['THE PROMOTION CODE INFORMED IS NOT VALID!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Customer not Authorized</div>
                </div>
                <input v-model="traducoes['ERROR: CUSTOMER NOT AUTHORIZED-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Invalid Credit Card</div>
                </div>
                <input v-model="traducoes['ERROR: INVALID PREAUTHORIZATION CREDIT CARD NUMBER!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Authentication (Username/Password)</div>
                </div>
                <input v-model="traducoes['ERROR: AUTHENTICATION (USERNAME/PASSSWORD) REQUIRED!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">No Rate is Available for youe Selection</div>
                </div>
                <input v-model="traducoes['ERROR: NO RATE IS AVAILABLE FOR YOUR SELECTION.-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Driver Name is Required</div>
                </div>
                <input v-model="traducoes['ERROR: DRIVER NAME IS REQUIRED!-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">User ou Password Incorrect</div>
                </div>
                <input v-model="traducoes['ERROR: USER OR PASSWORD INCORRECT-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Username/Password on WS Request Required</div>
                </div>
                <input v-model="traducoes['username/password on WS request required-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation Not Authorized</div>
                </div>
                <input v-model="traducoes['ERROR: RESERVATION NOT AUTHORIZED. RELEASE AUTHORIZATION!-' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

          <div v-if="pagina == 'pages'">
            <h5>Login</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title</div>
                </div>
                <input v-model="traducoes['login_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">SubTitle</div>
                </div>
                <input v-model="traducoes['login_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Login Reserved</div>
                </div>
                <input v-model="traducoes['login_reserved-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Login Client</div>
                </div>
                <input v-model="traducoes['login_cliente-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Login Driver</div>
                </div>
                <input v-model="traducoes['login_driver-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Client ID</div>
                </div>
                <input v-model="traducoes['clientID-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Username</div>
                </div>
                <input v-model="traducoes['username-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Password</div>
                </div>
                <input v-model="traducoes['senha-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email</div>
                </div>
                <input v-model="traducoes['email2333-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Send</div>
                </div>
                <input v-model="traducoes['loginEntrar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Send (reserved)</div>
                </div>
                <input v-model="traducoes['loginEntrar1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Register</div>
                </div>
                <input v-model="traducoes['loginRegistar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Register (reserved)</div>
                </div>
                <input v-model="traducoes['loginRegistar1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Recovery</div>
                </div>
                <input v-model="traducoes['loginRecuperar-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Register</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title</div>
                </div>
                <input v-model="traducoes['registar_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">SubTitle</div>
                </div>
                <input v-model="traducoes['registar_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Register Reserved</div>
                </div>
                <input v-model="traducoes['registar_reserved-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Register Reserved (Login)</div>
                </div>
                <input v-model="traducoes['registar_reserved1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Driver Name</div>
                </div>
                <input v-model="traducoes['driver_Name-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Date of Birth</div>
                </div>
                <input v-model="traducoes['date_of_Birth-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Country</div>
                </div>
                <input v-model="traducoes['country-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Address</div>
                </div>
                <input v-model="traducoes['address-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Postal Code</div>
                </div>
                <input v-model="traducoes['postal_Code-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">City</div>
                </div>
                <input v-model="traducoes['city-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Number</div>
                </div>
                <input v-model="traducoes['license_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Country</div>
                </div>
                <input v-model="traducoes['license_Country-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type</div>
                </div>
                <input v-model="traducoes['document_Type-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type (Other)</div>
                </div>
                <input v-model="traducoes['document_Type-0-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type (Identity Card)</div>
                </div>
                <input v-model="traducoes['document_Type-1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type (Passport)</div>
                </div>
                <input v-model="traducoes['document_Type-2-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Number</div>
                </div>
                <input v-model="traducoes['document_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Country</div>
                </div>
                <input v-model="traducoes['document_Place-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Passport Number</div>
                </div>
                <input v-model="traducoes['passportNumber-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Id Number</div>
                </div>
                <input v-model="traducoes['idNumber-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type</div>
                </div>
                <input v-model="traducoes['documentType-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Passport</div>
                </div>
                <input v-model="traducoes['documentTypePAssport-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document ID</div>
                </div>
                <input v-model="traducoes['documentTypeID-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Tax Number</div>
                </div>
                <input v-model="traducoes['tax_number-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Phone Number</div>
                </div>
                <input v-model="traducoes['phone_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Mobile Number</div>
                </div>
                <input v-model="traducoes['mobile_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email</div>
                </div>
                <input v-model="traducoes['email1sf23-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Password</div>
                </div>
                <input v-model="traducoes['senha332-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Repeat Password</div>
                </div>
                <input v-model="traducoes['senha123f-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Send</div>
                </div>
                <input v-model="traducoes['registarConta-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Register (reserved)</div>
                </div>
                <input v-model="traducoes['registarCont1-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Create an account</div>
                </div>
                <input v-model="traducoes['registarContCartaoCredito1-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirm</div>
                </div>
                <input v-model="traducoes['registarContCartaoCredito-ok-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cancel</div>
                </div>
                <input v-model="traducoes['registarContCartaoCredito-cancel-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <!--<div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Message Success</div>
                </div>
                <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="traducoes['registarSuc-' + sel]"></vue-editor>
              </div>
            </div>-->
            <h6>Text Success</h6>
            <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="traducoes['registarSuc-' + sel]"></vue-editor>
            <div class="clearfix"></div>

            <h5>Recovery</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title</div>
                </div>
                <input v-model="traducoes['recuperar_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">SubTitle</div>
                </div>
                <input v-model="traducoes['recuperar_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email</div>
                </div>
                <input v-model="traducoes['email233-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button</div>
                </div>
                <input v-model="traducoes['recuperarbot-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <h6>Text Success</h6>
            <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="traducoes['recuperarSuc-' + sel]"></vue-editor>
            <div class="clearfix"></div>
            <!--<div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Message Success</div>
                </div>
                <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="traducoes['recuperarSuc-' + sel]"></vue-editor>
              </div>
            </div>-->
          </div>

          <div v-if="pagina == 'contapessoal'">
            <h5>Menu Client</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu Dashboard</div>
                </div>
                <input v-model="traducoes['conta_pessoal_driver-deshboard-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu User</div>
                </div>
                <input v-model="traducoes['conta_pessoal_driver-user-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu Logout</div>
                </div>
                <input v-model="traducoes['conta_pessoal_driver-logout-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <h5>Menu Driver</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu Dashboard</div>
                </div>
                <input v-model="traducoes['conta_pessoal_client-deshboard-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu User</div>
                </div>
                <input v-model="traducoes['conta_pessoal_client-user-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Menu Logout</div>
                </div>
                <input v-model="traducoes['conta_pessoal_client-logout-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <h5>Reserved Area User</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Client ID</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-clientID-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Username</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-username-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Name</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-name-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-email-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Email Notification</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-email_Notification-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Password</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-TitlePassword-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Password</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-Password-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">New Password</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-passNova-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Repeat New Password</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-passNovaRep-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Save Password</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-ModifyPassword-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Address</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-Address-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Postal Code</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-PostalCode-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">City</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-City-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Country</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-Country-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Created At</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-CreatedAt-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Date of Birth</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-DateBirth-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Date</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-LicenseDate-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Number</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-LicenseNumber-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Place</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-license_Place-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">License Country</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-license_Country-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Type</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-document_Type-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Number</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-document_Number-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Date</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-document_Date-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Document Place</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-document_Place-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Mobile Phone</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-MobilePhone-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Phone</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-Phone-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Observation</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-Observation-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Tax Number</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-TaxNumber-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button UPDATE</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-UPDATE1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Update User Success</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-updateusersuccess-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Update Password Success</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-passwordsuccess-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Passwords do not match</div>
                </div>
                <input v-model="traducoes['conta_pessoal_user-passwordInvalidade-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Reserved</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title</div>
                </div>
                <input v-model="traducoes['conta_pessoal_driver-titulo-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-Reservation-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Status Description</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-StatusDescription-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Pickup Station</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-PickupStation-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Pickup Date</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-PickupDate-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Drop Off Station</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-DropOffStation-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Drop Off Date</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-DropOffDate-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Creation Date</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-CreationDate-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation Preview Value</div>
                </div>
                <input v-model="traducoes['conta_pessoal_reserved-ReservationPreviewValue-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <h5>Reservation States</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Archived</div>
                </div>
                <input v-model="traducoes['estado-Archived-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">NoShow</div>
                </div>
                <input v-model="traducoes['estado-NoShow-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Processed</div>
                </div>
                <input v-model="traducoes['estado-Processed-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmed</div>
                </div>
                <input v-model="traducoes['estado-Confirmed-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cancelled by the customer</div>
                </div>
                <input v-model="traducoes['estado-Cancelled by the customer-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Waiting for payment</div>
                </div>
                <input v-model="traducoes['estado-waitingpayment-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Under analysis</div>
                </div>
                <input v-model="traducoes['estado-under_analysis-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Turn-down</div>
                </div>
                <input v-model="traducoes['estado-turn_down-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">To be confirmed</div>
                </div>
                <input v-model="traducoes['estado-waiting_confirmation-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Not confirmed</div>
                </div>
                <input v-model="traducoes['estado-not_confirmed-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Filters</div>
                </div>
                <input v-model="traducoes['filters-' + sel]" type="text" class="form-control">
              </div>
            </div>

          </div>

          <div v-if="pagina == 'reserved'">
            <h5>Reserved</h5>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title car</div>
                </div>
                <input v-model="traducoes['reserved_title-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Subtitle car</div>
                </div>
                <input v-model="traducoes['reserved_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Choose car</div>
                </div>
                <input v-model="traducoes['reserved-escolhaCarro-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Booking details</div>
                </div>
                <input v-model="traducoes['reserved-detalhesReserva-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Payment</div>
                </div>
                <input v-model="traducoes['reserved-pagamento-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Good trip</div>
                </div>
                <input v-model="traducoes['reserved-boaViagem-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">At where</div>
                </div>
                <input v-model="traducoes['reserved-onde-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">When</div>
                </div>
                <input v-model="traducoes['reserved-quando-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Book by</div>
                </div>
                <input v-model="traducoes['reserved-reservarPor-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Total</div>
                </div>
                <input v-model="traducoes['reserved-total-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Extras</div>
                </div>
                <input v-model="traducoes['reserved-extras-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Info </div>
                </div>
                <input v-model="traducoes['extras-more-info-' + sel]" type="text" class="form-control">
              </div>
              <label class="labelInfo" for="extras"><small>(more extras info)</small></label>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Quantity</div>
                </div>
                <input v-model="traducoes['reserved-quantidade-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Franchise Value</div>
                </div>
                <input v-model="traducoes['reserved-valor_franquia-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Condutor</div>
                </div>
                <input v-model="traducoes['reserved-seleccionarCondutor-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Other</div>
                </div>
                <input v-model="traducoes['reserved-add-driver-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">or Similar</div>
                </div>
                <input v-model="traducoes['similar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Day</div>
                </div>
                <input v-model="traducoes['reserved-dia-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Days</div>
                </div>
                <input v-model="traducoes['reserved-dias-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Conductor Name</div>
                </div>
                <input v-model="traducoes['reserved-nome-condutor-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Edit Guest</div>
                </div>
                <input v-model="traducoes['edit-dados-guest-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Conductor</div>
                </div>
                <input v-model="traducoes['reserved-condutor-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Promotion Code</div>
                </div>
                <input v-model="traducoes['reserved-promotion-code1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Promotion Code</div>
                </div>
                <input v-model="traducoes['reserved-promotion-code-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Booking Summary</div>
                </div>
                <input v-model="traducoes['reserved-suamrio-reserva-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-out</div>
                </div>
                <input v-model="traducoes['reserved-suamrio-levantamento-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Check-in</div>
                </div>
                <input v-model="traducoes['reserved-suamrio-devolucao-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Kilometers</div>
                </div>
                <input v-model="traducoes['kilometers-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Free kms per day</div>
                </div>
                <input v-model="traducoes['free_kms_per_day-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Additional kms value</div>
                </div>
                <input v-model="traducoes['additional_kms_value-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Kms value</div>
                </div>
                <input v-model="traducoes['kms_value-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Included</div>
                </div>
                <input v-model="traducoes['reserved-incluido-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Description Client Footer (html)</div>
                </div>
                <input v-model="traducoes['reserved-descricao-final-pagamentoClient-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Description Payment (html)</div>
                </div>
                <input v-model="traducoes['reserved-descricao-final-pagamento-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Description Payment 1 (html)</div>
                </div>
                <input v-model="traducoes['reserved-descricao-final-pagamentoXX-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Pay through paypal</div>
                </div>
                <input v-model="traducoes['reserved-descricao-final-pagamento1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Guarantee your car (html)</div>
                </div>
                <input v-model="traducoes['reserved-descricao-final-pagamento2-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Modal Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cartaocredito-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Number Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cartaonumero-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Name Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cartaonome-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Date Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cartaodata-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Save Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cartaoguardar-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Cancel Credit Card</div>
                </div>
                <input v-model="traducoes['reserved-cancelar-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation confirmation required 1 (html)</div>
                </div>
                <input v-model="traducoes['reserved-confirmacao1-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation confirmation required 2 (html)</div>
                </div>
                <input v-model="traducoes['reserved-confirmacao2-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation confirmation required 3 (html)</div>
                </div>
                <input v-model="traducoes['reserved-confirmacao3-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Downlaod PDF</div>
                </div>
                <input v-model="traducoes['reserved-download-pdf-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Booking made successfully</div>
                </div>
                <input v-model="traducoes['reserved-reserva-sucesso-n-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Create Driver</div>
                </div>
                <input v-model="traducoes['reserved-criarcontaConfirmed-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation Failed</div>
                </div>
                <input v-model="traducoes['reserved-reserva-erro-n-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirm Reservation</div>
                </div>
                <input v-model="traducoes['reserved-confirmar-reserva-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Sign in / Create Account</div>
                </div>
                <input v-model="traducoes['reserved-entrar-criar-conta-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Date of Birth</div>
                </div>
                <input v-model="traducoes['reserved-data-aniversario-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Select Driver</div>
                </div>
                <input v-model="traducoes['reserved-escolha-condutor-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Booking summary Client</div>
                </div>
                <input v-model="traducoes['reserved-sumarioReserva-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Booking summary Driver</div>
                </div>
                <input v-model="traducoes['reserved-sumarioReserva-driver-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmed Title</div>
                </div>
                <input v-model="traducoes['confirmed_title--' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Confirmed Subtitle</div>
                </div>
                <input v-model="traducoes['confirmed_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Failed Title</div>
                </div>
                <input v-model="traducoes['failed_title--' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Failed Subtitle</div>
                </div>
                <input v-model="traducoes['failed_subtitle-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Try to Pay PayPal Again</div>
                </div>
                <input v-model="traducoes['try-novamente-paypal-' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Title Guest</div>
                </div>
                <input v-model="traducoes['reserved_titleguest-' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Button Guest</div>
                </div>
                <input v-model="traducoes['reserved_buttonguest-' + sel]" type="text" class="form-control">
              </div>
            </div>

          </div>
          <div v-if="pagina == 'emails'">
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Company</div>
                </div>
                <input v-model="traducoes['email_empresa_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Hello</div>
                </div>
                <input v-model="traducoes['email_hello_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Verify</div>
                </div>
                <input v-model="traducoes['email_verify_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Download</div>
                </div>
                <input v-model="traducoes['email_download_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Thanks</div>
                </div>
                <input v-model="traducoes['email_thanks_' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>
          <div v-if="pagina == 'pdf'">
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Dear</div>
                </div>
                <input v-model="traducoes['pdf_dear_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Thanks for</div>
                </div>
                <input v-model="traducoes['pdf_thanks_for_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Your Rental Details</div>
                </div>
                <input v-model="traducoes['pdf_rental_details_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Reservation Number</div>
                </div>
                <input v-model="traducoes['pdf_reservation_number_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Pick Up</div>
                </div>
                <input v-model="traducoes['pdf_pickup_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Address</div>
                </div>
                <input v-model="traducoes['pdf_address_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Phone Number</div>
                </div>
                <input v-model="traducoes['pdf_phone_number_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Return</div>
                </div>
                <input v-model="traducoes['pdf_return_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Provide Flight Part One</div>
                </div>
                <input v-model="traducoes['pdf_provide_flight_part_one_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Provide Flight Part Two</div>
                </div>
                <input v-model="traducoes['pdf_provide_flight_part_two_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Car Type</div>
                </div>
                <input v-model="traducoes['pdf_car_type_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Rate</div>
                </div>
                <input v-model="traducoes['pdf_rate_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Your rental total is</div>
                </div>
                <input v-model="traducoes['pdf_your_rental_total_part_one_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">which includes the below</div>
                </div>
                <input v-model="traducoes['pdf_your_rental_total_part_two_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Included</div>
                </div>
                <input v-model="traducoes['pdf_included_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Per day</div>
                </div>
                <input v-model="traducoes['pdf_per_day_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Per Rental</div>
                </div>
                <input v-model="traducoes['pdf_per_rental_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Deposit</div>
                </div>
                <input v-model="traducoes['pdf_deposit_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Has Been Taken</div>
                </div>
                <input v-model="traducoes['pdf_has_been_taken_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Damage Part One</div>
                </div>
                <input v-model="traducoes['pdf_damage_part_one_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Damage Part Two</div>
                </div>
                <input v-model="traducoes['pdf_damage_part_two_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Duration</div>
                </div>
                <input v-model="traducoes['duration_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Days</div>
                </div>
                <input v-model="traducoes['days_' + sel]" type="text" class="form-control">
              </div>
            </div>

            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Price Details</div>
                </div>
                <input v-model="traducoes['pdf_your_price_details_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">See Below Vehicle</div>
                </div>
                <input v-model="traducoes['pdf_please_see_below_vehicle_' + sel]" type="text" class="form-control">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Has Been Pre Autrorized</div>
                </div>
                <input v-model="traducoes['pdf_has_been_pre_authorized_' + sel]" type="text" class="form-control">
              </div>
            </div>
          </div>

        </b-tab>
      </b-tabs>
      <div class="clearfix"></div>
      <button type="button" @click="submitTrad" class="btn btn-primary float-right m-t-10">UPDATE</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import PAISES from './../components/paises.json'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.min.css'
import { VueEditor } from 'vue2-editor'

export default {
  components: { Treeselect, VueEditor },
  name: 'adminLinguas',
  data () {
    return {
      linguas: [],
      form: {
      },
      value: '',
      sel: '',
      paises: PAISES,
      traducoes: {},
      pagina: 'general'
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Languages')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS',
      'SET_LOAD1'
    ]),
    normalizer (a) {
      return {
        id: a.code,
        label: a.emoji + ' ' + a.name
      }
    },
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.linguas = JSON.parse(this.$store.state.option.langs)
        this.traducoes = this.$store.state.option
        this.sel = this.linguas[0]
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    // linguas
    submitLang () {
      this.SET_LOAD1(true)
      this.axios.post('/options', { 'langs': JSON.stringify(this.linguas) }).then((res) => {
        this.SET_TOAST({ msg: 'Updated successfully' })
        this.SET_OPTIONS(res.data)
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    // traducoes
    submitTrad () {
      this.SET_LOAD1(true)
      this.axios.post('/options', this.traducoes).then((res) => {
        this.SET_TOAST({ msg: 'Updated successfully' })
        this.SET_OPTIONS(res.data)
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      var data = new FormData()
      data.append('image', file)
      this.axios.post('/multimedia', data).then((res) => {
        Editor.insertEmbed(cursorLocation, 'image', './../../images/' + res.data.image)
        resetUploader()
      }, (er) => {})
    }
  }
}
</script>
<style scoped>
.labelInfo {
  margin-top: 0px
}
</style>
